export default __webpack_public_path__ + "static/time-consuming-41c7a2a42e5970abf74bd8f0925e7a7a.webp";